import*as s from"../node_modules/@metamask/utils/node_modules/superstruct/dist/index.js";import{getDefaultExportFromNamespaceIfNotNamed as e}from"./_commonjsHelpers.js";var o=e(s);export{o as default};
